import { useAuth } from '@lastbrand/fe-common/universal-auth'
import React from 'react'

import { useStatsigDynamicLocaleConfig } from '@src/experiments/statsig-integration'
import useDeviceInfo, { DEVICE_TYPES } from '@src/quince-site-common/src/hooks/useDeviceInfo'

import ApplePayButton, { ApplePayConfig } from '../apple-pay-button/apple-pay-button.component'

import { ExpressPayConfig } from './express-pay.types'

export interface ExpressPayProps {
  config?: ExpressPayConfig
  productPrice?: number
  className?: string
  dataSelectorKey?: string
  onReady?: () => void
  enableAnimation?: boolean
  disableClick?: boolean
}

export const useIsExpressPayEnabled = () => {
  const deviceInfo = useDeviceInfo()
  const { expressCheckoutEnabled = false } = useStatsigDynamicLocaleConfig()
  return expressCheckoutEnabled && deviceInfo.deviceType === DEVICE_TYPES.MOBILE
}

const ExpressPay = ({
  config,
  productPrice,
  className,
  dataSelectorKey,
  onReady,
  enableAnimation,
  disableClick,
}: ExpressPayProps) => {
  const { isLoggedIn } = useAuth()

  if (!config || config.disabled) {
    return null
  }

  const applePayConfig: ApplePayConfig = {
    getCheckoutDetails: config.getCheckoutDetails,
    validateApplePayClick: config.validateClick,
    onError: config.onError,
    updateShippingAddress: config.updateShippingAddress,
    updateShippingOption: config.updateShippingOption,
    checkoutExpressUpdateDetail: config.checkoutExpressUpdateDetail,
    updateExpressCompleteDetails: config.updateExpressCompleteDetails,
    capture: config.capture,
    skipEmail: isLoggedIn ? true : config.skipEmail,
    disableApplePayExpress: config.disabled,
  }

  return (
    <>
      <ApplePayButton
        applePayConfig={applePayConfig}
        productPrice={productPrice}
        className={className}
        dataSelectorKey={dataSelectorKey}
        onReady={onReady}
        enableAnimation={enableAnimation}
        disableClick={disableClick}
      />
    </>
  )
}

export default ExpressPay
